// extracted by mini-css-extract-plugin
export var darkMode = "_a-0";